import React from "react";
import { useSelector } from "react-redux";

const Profile = () => {
  const { auth } = useSelector((store) => store);

  

  return (
    <div className="m-11 flex flex-col justify-center items-center">
      <div className="w-max p-2 lg:p-12">
        <h1 className="text-lg font-bold py-4 ml-3 text-center">My Details</h1>
        <div className="space-y-3">
          <div className="flex flex-col justify-center items-center">
            <p>
              <span className="text-md font-semibold pr-2">First Name:</span>
              {auth?.user?.firstName}
            </p>
            <p>
              <span className="text-md font-semibold pr-2">Last Name:</span>
              {auth?.user?.lastName}
            </p>
            <p className="break-all	">
              <span className="text-md font-semibold pr-2">Email:</span>{" "}
              {auth?.user?.email}
            </p>
            <p>
              <span className="text-md font-semibold pr-2">Phone Number:</span>
              {auth?.user?.phone}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
